import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TicketRaisedModelComponent } from '../ticket-raised-model/ticket-raised-model.component';

@Component({
  selector: 'app-help-support',
  templateUrl: './help-support.component.html',
  styleUrl: './help-support.component.scss'
})
export class HelpSupportComponent {

  constructor(public dialog: MatDialog){

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(TicketRaisedModelComponent, {
      width: '50%',

    });
  
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
